// AD-14 | Set option in the buy box (X3, X5 x2, X8 product pages)
//   control = today's buy box (single unit only)
//   v1      = "Choose your setup": the single unit (default) or one set, above quantity.
//             Picking the set makes Add to cart add the set product; the button label/price, the
//             Shop Pay line and the mobile sticky bar follow the selection.
// Both groups: the price block is turned on for mobile (hidden today), so the test doesn't also
// measure the price display. Visits from Google campaign 24221621980 are excluded.
// Prices all come from Shopify (/products/<handle>.js); the option only shows when the set is
// available and its savings are above $0.
//
// Wrapped in its own function scope: other test scripts on the page also declare top-level
// `const iframe` / `realLog`, and top-level consts are shared across scripts.
(function () {

// 1. Create an invisible iframe to bypass the theme's silencer
const iframe = document.createElement('iframe');
iframe.style.display = 'none';
document.body.appendChild(iframe);

// 2. Steal its untouched console.log and warn functions
const realLog = iframe.contentWindow.console.log;
const realWarn = iframe.contentWindow.console.warn;

window.gbEvents = window.gbEvents || [];

// =========================================================================
// ---> TEST CONFIG
// =========================================================================
const X3 = 'airdog-x3-home-air-purifier-215-sq-ft';
const X5 = 'airdog-x5-home-air-purifier-1600-sq-ft';
const X5_PLUS = 'airdog-x5plus-air-purifier-up-to-1600-sq-ft';
const X8 = 'airdog-x8-home-air-purifier-1000-sq-ft';

// Per page: which set to offer, the other unit in it, and copy (copy only; prices come from Shopify).
// savingsUnit: the unit inside the set whose price counts toward "savings" (the X5+ page offers
// the X3 + X5 set, which contains the regular X5, so savings use the X5's price there).
const PAGES = {
	[X8]: {
		set: 'airdog-x3-x8',
		other: X3,
		savingsUnit: X8,
		singleTitle: 'Just the X8',
		setTitle: 'Add an X3 for the bedroom',
		setDetail: 'Second room, up to 860 ft²',
	},
	[X5]: {
		set: 'airdog-x3-x5',
		other: X3,
		savingsUnit: X5,
		singleTitle: 'Just the X5',
		setTitle: 'Add an X3 for the bedroom',
		setDetail: 'Second room, up to 860 ft²',
	},
	[X5_PLUS]: {
		set: 'airdog-x3-x5',
		other: X3,
		savingsUnit: X5,
		singleTitle: 'Just the X5+',
		setTitle: 'Add an X3 for the bedroom',
		setDetail: 'Second room, up to 860 ft²',
	},
	[X3]: {
		set: 'airdog-x3-x5',
		other: X5,
		savingsUnit: X3,
		singleTitle: 'Just the X3',
		setTitle: 'Add an X5 for the living room',
		setDetail: 'Second room, up to 1,600 ft²',
	},
};

const EXCLUDED_CAMPAIGN = '24221621980';

const AD14 = {
	testId: 'AD14',
	variant: null,
	reporting: false, // true once a live (non-preview) visitor is assigned
};

// Current product handle from the URL (/products/<handle> or /collections/x/products/<handle>)
const currentHandle = (window.location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];

// =========================================================================
// ---> HELPERS
// =========================================================================
function ad14Track(eventName, params) {
	if (!AD14.reporting) return;
	window.dataLayer = window.dataLayer || [];
	function gtag() {
		dataLayer.push(arguments);
	}
	gtag('event', eventName, {
		experiment_id: AD14.testId,
		experiment_variant: AD14.variant,
		send_to: 'G-Y4VGNLBJPF',
		transport_type: 'beacon',
		...params,
	});
}

// Visits from the excluded Google campaign: the campaign ID arrives in the landing URL; remember
// it for the rest of the session so later pages in the same visit are excluded too.
function isExcludedVisit() {
	try {
		const params = new URLSearchParams(window.location.search);
		const fromUrl = ['gad_campaignid', 'utm_campaign', 'utm_id'].some((key) => params.get(key) === EXCLUDED_CAMPAIGN);
		if (fromUrl) sessionStorage.setItem('ad14_excluded', '1');
		return fromUrl || sessionStorage.getItem('ad14_excluded') === '1';
	} catch (error) {
		return window.location.search.includes(EXCLUDED_CAMPAIGN);
	}
}

function poll(sel, cb, attempts = 0) {
	const el = document.querySelector(sel);
	if (el) cb(el);
	else if (attempts < 200) setTimeout(() => poll(sel, cb, attempts + 1), 50);
}

// Both groups: show the price block on mobile (section-main-product.css hides it under 750px).
function showMobilePrice() {
	if (document.getElementById('ad14-mobile-price')) return;
	const style = document.createElement('style');
	style.id = 'ad14-mobile-price';
	style.innerHTML = `@media screen and (max-width: 749px) { html [id^='price-template'] { display: block !important; } }`;
	document.head.appendChild(style);
}

// =========================================================================
// ---> VARIATION
// =========================================================================
function testCode() {
	(async function initSetOption() {
		const page = PAGES[currentHandle];
		if (!page || document.getElementById('ad14-setup')) return;

		realLog(
			'%cAD-14 | Set option in the buy box',
			"color: white; background-color:#202621; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;",
		);

		const fetchProduct = (handle) =>
			fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
				.then((response) => (response.ok ? response.json() : null))
				.catch(() => null);

		const [unit, set, other, savingsUnit] = await Promise.all([
			fetchProduct(currentHandle),
			fetchProduct(page.set),
			fetchProduct(page.other),
			page.savingsUnit === currentHandle ? null : fetchProduct(page.savingsUnit),
		]);
		const firstVariant = (product) => product && (product.variants.find((v) => v.available) || product.variants[0]);
		const unitVariant = firstVariant(unit);
		const setVariant = set && set.variants.find((v) => v.available);
		const otherVariant = firstVariant(other);
		const savingsVariant = savingsUnit ? firstVariant(savingsUnit) : unitVariant;

		// Only show when the set can be bought and the numbers make sense; otherwise render nothing.
		if (!unitVariant || !setVariant || !otherVariant || !savingsVariant) {
			realWarn('[AD-14] Set option hidden: set not available or product data missing.');
			return;
		}
		const addOn = setVariant.price - unitVariant.price;
		const savings = savingsVariant.price + otherVariant.price - setVariant.price;
		if (savings <= 0) {
			realWarn(`[AD-14] Set option hidden: savings came out to ${savings / 100} for ${page.set}.`);
			return;
		}

		// Prices: whole dollars in the cards ($1,319), cents on the button ($1,319.00), like today.
		const dollars = (cents) =>
			'$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
		const money = (cents) => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		const escapeHtml = (value) =>
			String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
		const thumb = (product) => {
			const src = product && (product.featured_image || (product.images && product.images[0]));
			if (!src) return '';
			const url = (src.startsWith('//') ? 'https:' + src : src) + (src.includes('?') ? '&' : '?') + 'width=120';
			return `<img src="${escapeHtml(url)}" alt="" width="44" height="44" loading="lazy">`;
		};

		// Coverage line for the single unit: the page's own "For rooms up to …" text
		const coverageEl = document.querySelector('.product--coverage');
		const unitCoverage = coverageEl ? coverageEl.textContent.trim() : '';
		const unitCompare = unitVariant.compare_at_price > unitVariant.price ? unitVariant.compare_at_price : 0;

		// ---------------------------------------------------------------------
		// Styles
		// ---------------------------------------------------------------------
		const style = document.createElement('style');
		style.id = 'ad14-styles';
		style.innerHTML = `
#ad14-setup { margin: 0; padding: 0; border: 0; min-width: 0; }
#ad14-setup legend { padding: 0; margin: 0 0 10px; font-size: 12px; font-weight: 700; opacity: 0.85; }
#ad14-setup .ad14-options { display: grid; gap: 10px; }
#ad14-setup .ad14-option {
	position: relative;
	display: grid;
	grid-template-columns: 20px 44px minmax(0, 1fr) auto;
	align-items: center;
	gap: 12px;
	padding: 12px 14px;
	border: 1px solid rgba(255, 255, 255, 0.35);
	border-radius: 8px;
	cursor: pointer;
	transition: border-color 0.15s ease;
}
#ad14-setup .ad14-option:hover { border-color: rgba(255, 255, 255, 0.7); }
#ad14-setup .ad14-option:has(input:checked) { border: 2px solid #fff; padding: 11px 13px; }
#ad14-setup input[type='radio'] { width: 18px; height: 18px; margin: 0; accent-color: #fff; cursor: pointer; }
#ad14-setup input[type='radio']:focus-visible { outline: 2px solid #9ece7b; outline-offset: 3px; }
#ad14-setup .ad14-thumb { width: 44px; height: 44px; border-radius: 6px; background: #fff; overflow: hidden; display: flex; align-items: center; justify-content: center; }
#ad14-setup .ad14-thumb img { width: 100%; height: 100%; object-fit: contain; display: block; }
#ad14-setup .ad14-title { display: block; font-size: 14px; font-weight: 700; line-height: 1.25; }
#ad14-setup .ad14-detail { display: block; margin-top: 3px; font-size: 12px; line-height: 1.3; opacity: 0.85; }
#ad14-setup .ad14-save { display: block; margin-top: 3px; font-size: 12px; line-height: 1.3; color: #9ece7b; }
#ad14-setup .ad14-price { align-self: start; text-align: right; font-size: 14px; font-weight: 700; white-space: nowrap; }
#ad14-setup .ad14-price s { display: block; font-size: 12px; font-weight: 400; opacity: 0.7; }
`;
		document.head.appendChild(style);

		// ---------------------------------------------------------------------
		// Markup: "Choose your setup", inserted just above quantity
		// ---------------------------------------------------------------------
		const quantityBlock = document.querySelector('[id^="Quantity-Form-"]') || document.querySelector('.product-form__quantity');
		if (!quantityBlock) {
			realWarn('[AD-14] Quantity block not found; set option not added.');
			return;
		}
		quantityBlock.insertAdjacentHTML(
			'beforebegin',
			`<fieldset id="ad14-setup">
	<legend>Choose your setup</legend>
	<div class="ad14-options">
		<label class="ad14-option">
			<input type="radio" name="ad14-setup" value="single" checked>
			<span class="ad14-thumb" aria-hidden="true">${thumb(unit)}</span>
			<span>
				<span class="ad14-title">${escapeHtml(page.singleTitle)}</span>
				${unitCoverage ? `<span class="ad14-detail">${escapeHtml(unitCoverage)}</span>` : ''}
			</span>
			<span class="ad14-price">${dollars(unitVariant.price)}${
				unitCompare ? `<s><span class="visually-hidden">Regular price </span>${dollars(unitCompare)}</s>` : ''
			}</span>
		</label>
		<label class="ad14-option">
			<input type="radio" name="ad14-setup" value="set">
			<span class="ad14-thumb" aria-hidden="true">${thumb(set)}</span>
			<span>
				<span class="ad14-title">${escapeHtml(page.setTitle)}</span>
				<span class="ad14-detail">${escapeHtml(page.setDetail)}</span>
				<span class="ad14-save">Save ${dollars(savings)} vs. buying separately</span>
			</span>
			<span class="ad14-price"><span class="visually-hidden">Adds </span>+${dollars(addOn)}</span>
		</label>
	</div>
</fieldset>`,
		);
		ad14Track('set_option_viewed', { set_product: page.set, set_price: setVariant.price / 100 });

		// ---------------------------------------------------------------------
		// Selection: product ID, button, Shop Pay line, sticky bar
		// ---------------------------------------------------------------------
		const productForm = document.querySelector('product-form form[data-type="add-to-cart-form"]') || document.querySelector('product-form form');
		const idInput = productForm && productForm.querySelector('[name="id"]');
		const submitButton = document.querySelector('[id^="ProductSubmitButton-"]');
		const ctaLabel = submitButton && submitButton.querySelector('.cta-bold');
		const ctaPrice = submitButton && submitButton.querySelector('.mobile-cta-price');
		if (!idInput) {
			realWarn('[AD-14] Product form not found.');
			return;
		}

		const original = {
			id: idInput.value,
			label: ctaLabel ? ctaLabel.textContent : '',
			price: ctaPrice ? ctaPrice.textContent : '',
			sticky: null, // filled in when the sticky bar appears
		};
		let mode = 'single';

		// Shop Pay line: Shopify only knows this product's installments, so for the set we borrow the
		// payment terms element from the set's own product page (Shopify does the math). Until it
		// loads, or if it can't, the line is hidden rather than showing the single unit's amount.
		const termsHolder = document.querySelector('[id^="product-form-installment-"]');
		const originalTerms = termsHolder && termsHolder.querySelector('shopify-payment-terms');
		let setTerms = null;
		let setTermsRequest = null;
		function loadSetTerms() {
			if (!setTermsRequest) {
				setTermsRequest = fetch(`/products/${page.set}`)
					.then((response) => (response.ok ? response.text() : ''))
					.then((html) => {
						const found = new DOMParser().parseFromString(html, 'text/html').querySelector('shopify-payment-terms');
						if (!found) return null;
						const el = document.createElement('shopify-payment-terms');
						for (const attr of found.attributes) el.setAttribute(attr.name, attr.value);
						return el;
					})
					.catch(() => null);
			}
			return setTermsRequest;
		}
		async function showTerms(forSet) {
			if (!termsHolder || !originalTerms) return;
			if (!forSet) {
				if (setTerms && setTerms.isConnected) setTerms.replaceWith(originalTerms);
				termsHolder.hidden = false;
				return;
			}
			termsHolder.hidden = true;
			setTerms = await loadSetTerms();
			if (mode !== 'set') return; // switched back while loading
			if (setTerms) {
				originalTerms.replaceWith(setTerms);
				termsHolder.hidden = false;
			}
		}

		// Mobile sticky bar (.air2-holder, added by the product section on load)
		function updateSticky() {
			const stickyCta = document.querySelector('.air2-holder .air2-cta');
			const stickyPrice = document.querySelector('.air2-holder .air2-quality-holder > div:last-child');
			if (!stickyCta || !stickyPrice) return;
			const labelNode = [...stickyCta.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
			if (!original.sticky) original.sticky = { label: labelNode ? labelNode.textContent : '', price: stickyPrice.textContent };
			if (labelNode) labelNode.textContent = mode === 'set' ? 'Add set to cart ' : original.sticky.label;
			const usd = /USD/.test(original.sticky.price) ? ' USD' : '';
			stickyPrice.textContent = mode === 'set' ? money(setVariant.price) + usd : original.sticky.price;
		}
		poll('.air2-holder .air2-quality-holder', updateSticky);

		function select(newMode) {
			mode = newMode;
			const isSet = mode === 'set';
			idInput.value = isSet ? setVariant.id : original.id;
			if (ctaLabel) ctaLabel.textContent = isSet ? 'Add set to cart' : original.label;
			if (ctaPrice) ctaPrice.textContent = isSet ? money(setVariant.price) : original.price;
			updateSticky();
			showTerms(isSet);
			if (isSet) ad14Track('set_option_selected', { set_product: page.set, set_price: setVariant.price / 100 });
		}

		document.getElementById('ad14-setup').addEventListener('change', (event) => {
			if (event.target.name === 'ad14-setup') select(event.target.value);
		});

		// Add to cart carrying the set (main button and the sticky bar, which clicks the main button).
		// Custom event name so it doesn't double-count Shopify's own GA4 add_to_cart ecommerce event.
		productForm.addEventListener(
			'submit',
			() => {
				if (mode !== 'set') return;
				const quantityInput = document.querySelector('[id^="Quantity-template"], .quantity__input');
				const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
				ad14Track('set_add_to_cart', {
					set_product: page.set,
					set_price: setVariant.price / 100,
					quantity,
					value: (setVariant.price / 100) * quantity,
					currency: 'USD',
				});
			},
			true,
		);
	})();
}

// --->  MANUAL A/B TEST RANDOMIZER <---
(function () {
	const preview = true;

	// =========================================================================
	// ---> TEST TARGETING CONFIGURATION
	// =========================================================================
	const config = {
		// URL Filtering: X3, both X5 listings, X8 (exact product handle match)
		filterByUrls: true,
		allowedUrls: Object.keys(PAGES),

		// Device Filtering
		allowMobile: true,
		allowDesktop: true,
	};

	// Helper: Check if current URL is allowed
	function isUrlAllowed() {
		if (!config.filterByUrls) return true;
		// Exact handle match, so the X5 listing doesn't also match the X5+ one
		return config.allowedUrls.includes(currentHandle);
	}

	function isDeviceAllowed() {
		const mobileBreakpoint = 768;
		const isMobile = window.innerWidth < mobileBreakpoint;

		if (isMobile && !config.allowMobile) return false;
		if (!isMobile && !config.allowDesktop) return false;

		return true;
	}

	// Evaluate targeting before running test or preview logic
	if (!isUrlAllowed() || !isDeviceAllowed()) {
		realLog('Test skipped: Does not meet URL or Device targeting rules.');
		return; // Exit out of the A/B test wrapper entirely
	}
	if (isExcludedVisit()) {
		realLog('Test skipped: visit from excluded Google campaign ' + EXCLUDED_CAMPAIGN + '.');
		return;
	}
	// =========================================================================

	if (!preview) {
		// CHANGE PER TEST: letters, numbers and underscores only (GA4 rejects hyphens).
		// Drives both the cookie and the GA4 user property, e.g. "ab_AD14".
		// Register "ab_" + testId in GA4 as a user-scoped custom dimension before launch.
		const testId = AD14.testId;
		const cookieName = 'ab_' + testId;

		// Helper to read cookies
		function getCookie(name) {
			const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			return match ? match[2] : null;
		}

		// Check if user already has a variant cookie
		let variant = getCookie(cookieName);

		// If they are new, flip a coin (50/50 split) and assign them
		if (variant !== 'control' && variant !== 'v1') {
			variant = Math.random() < 0.5 ? 'control' : 'v1';

			// Write cookie so variant follows them everywhere (expires in 30 days)
			const date = new Date();
			date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
			document.cookie = cookieName + '=' + variant + ';expires=' + date.toUTCString() + ';path=/';
		}

		AD14.variant = variant;
		AD14.reporting = true;

		// =========================================================================
		// ---> SEND DIRECTLY TO GA4
		// =========================================================================
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}

		gtag('set', 'user_properties', {
			[cookieName]: variant,
		});

		// No debug_mode: GA4 treats the parameter as "debug" whenever it's present, even when false.
		gtag('event', 'experiment_impression', {
			experiment_id: testId,
			experiment_variant: variant,
			send_to: 'G-Y4VGNLBJPF',
		});
		// =========================================================================

		// Both groups: price block on mobile
		showMobilePrice();

		// Run the visual changes
		if (variant === 'v1') {
			realLog('MANUAL TEST: Variation active');
			testCode();
		} else {
			realLog('MANUAL TEST: Control active');
		}

		// Send the page view goal (if you still have a separate tracker looking for gbEvents)
		window.gbEvents.push('Page View');

		// Only if a quick checkout tracker exists on the page (it isn't defined in this theme).
		if (typeof window.initQuickCheckoutTracking === 'function') {
			if (document.readyState === 'complete') {
				window.initQuickCheckoutTracking();
			} else {
				window.addEventListener('load', window.initQuickCheckoutTracking);
			}
		}
	} else {
		// Preview: "?ad-14" turns on the variation for the rest of this browser tab (so it carries
		// across the X3/X5/X8 pages); "?ad-14-off" turns it off again.
		let previewOn = false;
		try {
			if (window.location.href.includes('ad-14-off')) sessionStorage.removeItem('ad14_preview');
			else if (window.location.href.includes('ad-14')) sessionStorage.setItem('ad14_preview', '1');
			previewOn = sessionStorage.getItem('ad14_preview') === '1';
		} catch (error) {
			previewOn = window.location.href.includes('ad-14') && !window.location.href.includes('ad-14-off');
		}
		if (previewOn) {
			realLog('%cPreview mode ACTIVE', "color: #F7F631; background-color:black; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;");
			showMobilePrice();
			testCode();
		}
	}
})();

})();
